import React from 'react';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
const MetaDataRow = (props) => {
    return (React.createElement(MetaDataBox, { className: "from" },
        React.createElement(Header, null, props.header),
        React.createElement(Body, null, props.body)));
};
export const MetaData = (props) => {
    if (props.metaData.length === 0) {
        return null;
    }
    return (React.createElement(MetaTable, null, props.metaData.map((data, i) => (React.createElement(MetaDataRow, { key: i, header: data.header, body: data.body })))));
};
const MetaTable = styled.table `
  display: block;
  border-collapse: collapse;
`;
const MetaDataBox = styled.tr `
  border-bottom: 1px solid ${THEME.BORDER_STRONG};
  font-size: 0.9em;
`;
const paddingTopBottom = 7;
const Header = styled.td `
  width: 1%;
  opacity: 0.6;
  color: ${THEME.COLOR_PRIMARY};
  text-align: right;
  padding: ${paddingTopBottom}px 7px ${paddingTopBottom}px
    ${THEME.GRID_SPACING}px;
  font-size: 0.85em;
`;
const Body = styled.td `
  padding: ${paddingTopBottom}px ${THEME.GRID_SPACING}px ${paddingTopBottom}px
    0px;
`;
//# sourceMappingURL=Helpers.js.map